import { withI18n } from 'react-i18next';

import CancelOrderModal from './CancelOrderModal';

export default withI18n()(CancelOrderModal);
